import { NavItemType, JobType } from '../types/interfaces';

export const navItems: NavItemType[] = [
  { path: '/', label: 'Home' },
  { path: '/work', label: 'Work' },
];

export const jobs: JobType[] = [
  {
    id: 1,
    role: 'Senior Frontend Engineer',
    company: {
      name: 'Lickd',
      link: 'https://app.lickd.co/',
    },
    dates: 'July 2025 - present',
    bulletPoints: [
      'Owned the frontend Typescript / React / Express codebase, taking responsibility for delivery of all new features, monitoring and fixing bugs, and ensuring stability of infrastructure.',
      'Led the implementation of multiple features, including the introduction of a completely new subscription model and improvements to key areas of the app such as search and checkout.',
      'Migrated from a legacy React 17/Node 14 codebase to a modern React 18/Node 22 setup.',
      'Introduced client-side data caching with React Query, greatly improving the user experience and fixing longstanding issues with stale data caused by attempting to sync server state with MobX.',
      'Fixed SSR memory leaks to improve site stability and significantly reduce server resources.',
      'Introduced unit, component and integration testing into a largely untested codebase.',
      'Worked with the QA department to ensure broad end-to-end test coverage.',
      'Reduced the number of Bugsnag errors from hundreds per day to only a handful of edge cases.',
      'Mentored mid-level engineers, providing comprehensive PR feedback and encouraging best practices.',
      'Championed performance, accessibility, and developer experience.',
    ],
  },
  {
    id: 2,
    role: 'Frontend Engineer',
    company: {
      name: 'Lickd',
      link: 'https://app.lickd.co/',
    },
    dates: 'April 2024 - July 2025',
    bulletPoints: [
      'Built React interfaces from Figma designs using Typescript.',
      'Wrote business logic to consume REST and GraphQL APIs.',
      'Wrote RFCs and implementation documents for improvements to the platform and user experience.',
      'Wrote, prioritised and completed Jira tickets in collaboration with the QA and Product departments.',
    ],
  },
  {
    id: 3,
    role: 'Web Developer',
    company: {
      name: 'Electric Putty',
      link: 'https://electricputty.co.uk/',
    },
    dates: 'October 2020 - June 2023',
    bulletPoints: [
      'Designed and built the frontend framework for Laravel applications, using vanilla JS and Vue.',
      'Developed and maintained Craft CMS sites.',
      'Integrated several standalone Vue / React apps into Craft CMS sites.',
      'Modernised the frontend architecture of BrandStencil, creating a reusable component library and implementing AA accessibility standards.',
    ],
  },
  {
    id: 4,
    role: 'Frontend Developer',
    company: {
      name: 'Wild Dog Design',
      link: 'https://www.wilddogdesign.co.uk/',
    },
    dates: 'May 2019 - October 2020',
    bulletPoints: [
      'Developed responsive websites from designs using SCSS, JavaScript and the Nunjucks templating engine.',
      'Contributed to Canvas, a Vue/Nuxt-powered SaaS platform for customised trip itineraries.',
      'Helped build a Carbon Emissions Calculator application using React and Redux.',
    ],
  },
];
